import { ProductionDistance } from '../types/OrganizationUnit'
import { SplitOption } from '../types/Survey/Analysis/Calculation'
import { OptimizationMode } from '../types/Survey/Analysis/Concept'
import { Type } from '../types/Survey/Element'
import { SurveyType } from '../types/Survey/Survey'

export const translation = {
  projectName: 'Archonic - Digital',

  header: {
    navigation: {
      default: [
        {
          name: 'Anmelden',
          link: '/',
        },
      ],
      ADMIN: [
        {
          name: 'Kunden',
          link: '/admin/customer',
        },
        {
          name: 'New Work Konfigurator',
          link: '/admin/naw',
        },
        {
          name: 'Controlling',
          link: '/admin/controlling',
        },
      ],
      isLoggedIn: {
        name: 'Abmelden',
      },
    },
  },

  login: {
    headline: 'Anmelden',
    cta: 'Anmelden',
    error: 'Anmeldung fehlgeschlagen. Falsche E-Mail oder Passwort.',
  },

  customer: {
    list: {
      titleSplit: {
        prefix: 'Deine ',
        suffix: 'Kunden.',
        subline: 'Hier ist eine Übersicht deiner Kunden.',
      },
      search: 'Suche',
      employeeCount: 'Kunden',
    },
    upsert: {
      title: {
        create: 'Kunde hinzufügen',
        update: 'Kunde bearbeiten',
      },
      logoUploadLabel: 'Logo hochladen',
      success: 'Der Kunde wurde erfolgreich gespeichert',
      error: 'Der Kunde konnte nicht gespeichert werden',
    },
    attributes: {
      name: 'Name',
      branch: 'Branche',
      employeeAmount: 'Anzahl Mitarbeiter',
      imageKey: 'Logo',
      companyType: 'Unternehmensgröße',
      companyTypeOption: {
        SMALL: 'Kleinunternehmen',
        MEDIUM: 'Mittelstand',
        LARGE: 'Konzern',
      },
      projectCount: 'Anzahl Projekte',
    },
  },

  controlling: {
    company: {
      list: {
        titleSplit: {
          prefix: 'Controlling - ',
          suffix: 'Unternehmen.',
        },
        search: 'Suche',
        companyCount: 'Unternehmen',
      },
      view: {
        titleSplit: {
          prefix: 'Unternehmen - ',
        },
      },
      upsert: {
        title: {
          create: 'Unternehmen hinzufügen',
          update: 'Unternehmen bearbeiten',
        },
        logoUploadLabel: 'Logo hochladen',
        success: 'Der Unternehmen wurde erfolgreich gespeichert',
        error: 'Der Unternehmen konnte nicht gespeichert werden',
      },
      attributes: {
        name: 'Name',
      },
    },
    kostenstelle: {
      list: {
        titleSplit: {
          suffix: 'Kostenstellen.',
        },
        search: 'Suche',
        kostenstelleCount: 'Kostenstellen',
      },
      view: {
        titleSplit: {
          prefix: 'Kostenstelle - ',
        },
      },
      upsert: {
        title: {
          create: 'Kostenstelle hinzufügen',
          update: 'Kostenstelle bearbeiten',
        },
        logoUploadLabel: 'Logo hochladen',
        success: 'Die Kostenstelle wurde erfolgreich gespeichert',
        error: 'Die Kostenstelle konnte nicht gespeichert werden',
      },
      attributes: {
        name: 'Name',
      },
    },
    yearSelection: {
      title: 'Jahr auswählen',
      placeholder: 'Jahr',
      confirmButton: 'Bestätigen',
      konstenstellenSwitch: 'Kostenstelle wechseln',
    },
    offer: {
      fileUploadLabel: 'Angebot hochladen',
      type: {
        INCOME: 'Einnahme',
        EXPENSE: 'Ausgabe',
      },
      interval: {
        title: 'Intervall',
        ONCE: 'Einmalig',
        MONTHLY: 'Monatlich',
      },
      add: {
        cta: 'Angebot hinzufügen',
        title: 'Angebot hinzufügen',
        error: 'Angebot konnte nicht angelegt werden.',
      },
      entry: {
        title: 'Teilprojekte',
        add: {
          title: 'Teilprojekt definieren',
          amount: 'Summe des Teilprojekts',
          startDate: 'Voraussichtliches Startdatum',
          alreadyAccepted: 'Wurde die Umsetzung bereits beauftragt?',
        },
        edit: {
          title: 'Teilprojekt bearbeiten',
          error: 'Teilprojekt konnte nicht gespeichert werden.',
        },
        list: {
          sum: 'Summe: ',
          startDate: 'Startdatum: ',
          alreadyAccepted: 'Beauftragt: ',
          alreadyAcceptedYes: 'Ja',
          alreadyAcceptedNo: 'Nein',
          totalSum: 'Gesammtsumme: ',
        },
        view: {
          title: 'Teilprojekt',
        },
      },
    },
    forecast: {
      title: 'Prognose',
      income: 'Einnahmen',
      expense: 'Ausgaben',
      amount: 'Betrag',
      scheduledDate: 'Geplantes Datum',
      add: {
        expense: {
          cta: 'Ausgabe hinzufügen',
          title: 'Ausgabe hinzufügen',
        },
        error: {
          projectMissing: 'Bitte wähle das entsprechende Projekt aus.',
        },
      },
      yearForecast: 'Jahresprognose',
      yearComparison: 'Vergleich zum Vorjahr: ',
      quarter: {
        0: 'Q1',
        1: 'Q2',
        2: 'Q3',
        3: 'Q4',
      },
      offerEntryList: {
        title: 'Teilprojekte:',
        noEntries: 'Keine Teilprojekte vorhanden.',
      },
      onlyAcceptedOfferEntries: 'Nur beauftragte Angebotspositionen',
    },
    arbeitspaketSelection: {
      title: 'Arbeitspaket wählen',
      add: {
        title: 'Arbeitspaket hinzufügen',
        selectKostenstelle: 'Kostenstelle wählen',
        error: 'Arbeitspaket konnte nicht hinzugefügt werden.',
      },
    },
  },

  naw: {
    survey: {
      list: {
        publicLink: 'Öffentlicher Link: ',
        publicLinkHint: 'Dieser Link ist nicht personalisiert, deshalb werden keine Daten vom Benutzer gespeichert.',
        contactImport: 'Kontakte Importieren via CSV',
        contactImportHint:
          'Für den Namen der Umfrage werden die Spalten Vorname, Nachname, Job-Titel und Company verwendet. Die bearbeitete CSV wird automatisch heruntergeladen, nachdem die Spalte urlParameter mit den entsprechenden Umfrage-URL befüllt wurde. Die CSV muss Komma separiert sein.',
        contactImportCTA: 'CSV Importieren',
        copyTooltip: 'Link kopieren',
        copySuccess: 'Link wurde kopiert',
        titleSplit: {
          suffix: 'New Work Konfigurator.',
          subline: 'Hier ist eine Übersicht deiner Umfragen.',
        },
        search: 'Suche',
        employeeCount: 'Umfragen',
        lastInteraction: 'Letzte Interaktion',
        furthestStep: {
          label: 'Interagiert bis',
          ARBEITSPLAETZE: 'Arbeitsplätze',
          FLAECHE: 'Fläche',
          SUMMARY: 'Zusammenfassung',
          PROMO: 'Promotion',
        },
      },
      upsert: {
        title: {
          create: 'Umfrage hinzufügen',
          update: 'Umfrage bearbeiten',
        },
        logoUploadLabel: 'Logo hochladen',
        success: 'Der Umfrage wurde erfolgreich gespeichert',
        error: 'Der Umfrage konnte nicht gespeichert werden',
      },
      attributes: {
        name: 'Name',
        mitarbeiter: 'Mitarbeiteranzahl',
        homeoffice: 'Homeoffice-Tage',
        collaborationPercentage: 'Arbeitsweisen',
        digitalPercentage: 'Digitalisierung',
        flaecheIst: 'Aktuelle Bürofläche',
        pricePerSquareMeter: 'Immobilienkosten',
        deskSharingPercentage: 'Desk-Sharing',
      },
      view: {
        titleSplit: {
          prefix: 'NAW-Umfrage: ',
          suffix: 'Projekte',
        },
        search: 'Suche',
        employeeCount: 'Projekte',
      },
      profile: {
        label: 'Arbeitsweisen',
        leftLabel: 'selten',
        rightLabel: 'häufig',
      },
      configuration: {
        mitarbeiter: { leftLabel: '50', rightLabel: '2.000', min: 50, max: 2000, step: 10, percentageSuffix: ' Mitarbeitende', initialize: 50 },
        homeoffice: { leftLabel: '0 von 5', rightLabel: '5 von 5', min: 0, max: 5, step: 1, percentageSuffix: ' Tage', initialize: 0 },
        collaborationPercentage: { leftLabel: 'Einzelarbeit', rightLabel: 'Kommunikation', initialize: 0 },
        digitalPercentage: { leftLabel: '100% analog', rightLabel: '100% digital', initialize: 0 },
        flaecheIst: { leftLabel: '500  m²', rightLabel: '20.000 m²', min: 500, max: 20000, step: 100, percentageSuffix: ' m²', initialize: 1000 },
        pricePerSquareMeter: { leftLabel: '5 €/m²', rightLabel: '40 €/m²', min: 5, max: 40, step: 1, percentageSuffix: ' €/m²', initialize: 20 },
        deskSharingPercentage: { leftLabel: '0,1', rightLabel: '1,0 (kein Desksharing)', min: 0.1, max: 1, step: 0.01 },
      },
      answer: {
        intro: {
          title: 'Wie groß muss das Büro von morgen sein?',
          description:
            'Kalkulieren Sie in zwei einfachen Schritten die Anzahl der benötigten Arbeitsplätze und Ihre potenziellen Kosteneinsparungen.',
        },
        arbeitsplaetze: {
          title: 'Schritt 1: Arbeitsplätze berechnen',
          mitarbeiter: 'Für wie viele Mitarbeitende soll die Bürofläche ausgelegt werden?',
          homeoffice: 'Wie viele Tage in der Woche arbeiten Ihre Mitarbeitenden im Homeoffice?',
          collaborationPercentage: 'Arbeiten Ihre Mitarbeitenden mehr in Einzelarbeit oder mehr in Kommunikation?',
        },
        flaeche: {
          title: 'Schritt 2: Flächenersparnis kalkulieren',
          digitalPercentage: 'Sind Ihre Arbeitsmaterialien bereits digitalisiert oder noch in analoger Form?',
          flaecheIst: 'Wie groß ist Ihre aktuelle Bürofläche?',
          pricePerSquareMeter: 'Wie hoch sind Ihre aktuellen monatlichen Miet- und Betriebskosten pro m²?',
        },
        summary: {
          config: {
            suffix: 'Zusammenfassung',
            glue: ' ',
            dynamicSuffix: 'Ihrer Angaben',
            subline: 'Passen Sie Ihre Angaben jetzt noch an:',
            showRanges: 'Angaben anpassen',
            hideRanges: 'Angaben ausblenden',
          },
          deskSharingAndSummary: {
            suffix: 'Desksharing-Quote',
            subline: 'Einsparungen durch Desksharing',
            slider: {
              label: (quote: string) => `Empfohlene Desksharing-Quote: ${quote}`,
            },
            text: {
              tillQuote: 'Bei einer Desksharing-Quote von ',
              tillTables: ' werden ',
              tableSuffix: 'Schreibtische',
              fromTables: ' für ',
              employeesSuffix: ' Mitarbeitende',
              fromEmployees: ' vorgesehen.',
            },
            textInvidivual: {
              tillQuote: 'Durch Ihre individuell eingestellte Desksharing-Quote von ',
              tillTables: ' werden ',
              tableSuffix: 'Schreibtische',
              fromTables: ' für ',
              employeesSuffix: ' Mitarbeitende vorgesehen.',
            },
            individualize: 'Jetzt Desksharing-Quote individuell anpassen:',
          },
          result: {
            suffix: 'Ihre Ersparnis',
            subline: 'Indikation nach erster Einschätzung',
            neueFlaeche: 'Neue Bürofläche',
            neueFlaecheDescription: '',
            ersparnisFlaeche: 'Ersparnis Bürofläche',
            ersparnisFlaecheDescription: '',
            jaehrlicheErsparnis: 'Jährliche Kosteneinsparung',
            jaehrlicheErsparnisDescription: '',
            noReduction: {
              text: [
                'Mit den ausgewählten Angaben lässt sich noch keine Ersparnis zu Ihrer bisherigen Bürofläche erzielen.',
                'Prüfen Sie Ihre Möglichkeiten über die Anpassung folgender Themen:',
              ],
              list: ['Homeoffice-Tage', 'Desksharing-Quote', 'Digitalisierung'],
            },
            noReductionSplitted: {
              preHomeofficeTage:
                'Mit den ausgewählten Angaben lässt sich noch keine Ersparnis zu Ihrer bisherigen Bürofläche erzielen. Prüfen Sie Ihre Möglichkeiten über die Anpassung der ',
              homeofficeTage: 'Homeoffice-Tage',
              preDesksharingQuote: ', der ',
              desksharingQuote: 'Desksharing-Quote',
              preDigitalisierung: ', oder der ',
              digitalisierung: 'Digitalisierung',
              postDigitalisierung: '.',
            },
          },
        },
        navigation: {
          submit: 'Nächste Schritte',
          start: `Los geht's`,
          back: 'Zurück',
        },
        promo: {
          prefix: 'Ihr Mehrwert',
          dynamicSuffix: ' durch MPS ARCHONIC',
          zielbildung: 'Strategische<br/>Zielbildentwicklung',
          planungUmsetzung: 'Planung und Umsetzung<br/>der Büroflächen',
          nutzerbedarfsanalyse: 'Onlinebasierte<br/>Nutzerbedarfsanalyse',
          changeManagement: 'Projektbegleitendes<br/>Change Management',
          text: [
            'Sie möchten mehr über die ersten Schritte und weitere Vorgehensweise erfahren?',
            'Daniel Kretz freut sich auf ein unverbindliches Erstgespräch mit Ihnen. Machen Sie jetzt einen Termin aus. ',
          ],
          video: {
            src: 'https://s3.eu-central-1.amazonaws.com/think-internet-gmbh.archonic-platform.storage/NAW_storage/loftfilm_neue_arbeitswelten.mp4',
            prefix: 'In vier Schritten zur',
            suffix: 'Neuen Arbeitswelt',
          },
          references: {
            prefix: 'Einblick in unsere',
            suffix: 'Referenzen',
          },
          cta: {
            download: 'Ergebnisse als PDF downloaden',
            meeting: 'Termin aussuchen',
            mail: 'Mail schreiben',
            phone: '+49 178 35 48 570',
            homepage: 'Website',
          },
          daniel: {
            firstname: 'Daniel ',
            lastname: 'Kretz',
            position: 'Associate Partner',
          },
        },
      },
    },
  },

  project: {
    list: {
      titleSplit: {
        prefix: 'Deine ',
        suffix: 'Projekte',
        glue: ' mit ',
        subline: 'Hier ist eine Übersicht deiner Projekte.',
      },
      search: 'Suche',
      employeeCount: 'Projekte',
    },
    upsert: {
      title: {
        create: 'Projekt hinzufügen',
        update: 'Projekt bearbeiten',
      },
      success: 'Das Projekt wurde erfolgreich gespeichert',
      error: 'Das Projekt konnte nicht gespeichert werden',
    },
    attributes: {
      name: 'Name',
      location: 'Standort',
      description: 'Beschreibung',
      employeeAmount: 'Anzahl Mitarbeiter',
      areaInQM: 'Fläche',
      furtherAssignments: 'Weitere Beauftragungen',
      furtherAssignmentOption: {
        CHANGE_MANAGEMENT: 'Change Management',
        CONCEPT: 'Konzept',
        DESIGN: 'Gestaltung',
        REALIZATION: 'Realisierung',
        PROJECT_MANAGEMENT: 'Projektmanagement',
      },
      orderVolumeAnalysis: 'Auftragsvolumen der Analyse in €',
      orderVolumeChangeManagement: 'Auftragsvolumen des Change Management in €',
      timeSpentAnalysis: 'Zeitaufwand der Analyse',
      timeSpentChangeManagement: 'Zeitaufwand des Change Management',
      surveyCount: 'Anzahl Umfragen',
    },
  },

  survey: {
    type: {
      [SurveyType.TEAM]: 'Nutzer-Umfrage',
      [SurveyType.MANAGER]: 'Nutzervertreter-Umfrage',
      [SurveyType.LEADER]: 'Entscheider-Umfrage',
    },
    list: {
      titleSplit: {
        prefix: 'Deine ',
        suffix: 'Analysen',
        glue: ' mit ',
        subline: 'Hier ist eine Übersicht deiner Analysen.',
      },
      selection: {
        analysis: 'Analyse',
        questions: 'Umfrage',
      },
      search: 'Suche',
      employeeCount: 'Umfragen',
    },
    upsert: {
      title: {
        create: 'Analyse hinzufügen',
        update: 'Analyse bearbeiten',
      },
      success: 'Die Analyse wurde erfolgreich gespeichert',
      error: 'Die Analyse konnte nicht gespeichert werden',
    },
    configuration: {
      factor: {
        einzelbueroQM: 'Einzelbüro',
      },
      section: {
        prebuild: 'Vorlagen',
        custom: 'Eigene Elemente',
      },
      save: 'Umfage speichern',
      openPreview: 'Vorschau öffnen',
      copyPublicLink: 'Öffentlichen Link kopieren',
      copiedPublicLink: 'Öffentlicher Link wurde kopiert',
      saved: 'gespeichert',
      error: 'speichern fehlgeschlagen',
      unsaved: 'nicht gespeichert',
      numberInput: {
        suffix: 'Suffix',
      },
      dynamicOptionsWithNumberAndSelectionOption: {
        name: 'Option',
      },
      dynamicOptionsWithNumberAndSelection: {
        active: 'Aktiv',
        add: 'Option hinzufügen',
        numberSuffix: 'Suffix',
        normLabel: 'Empfehlungs-Label',
      },
      organizationUnitNumberInput: {
        empty:
          'Die Wahl für Organisationsschnittstellen wird automatisch ausgeblendet, da keine Organisationseinheiten in der Umfrage festgelegt wurden.',
      },
      dynamicNumberDescriptionAmountInput: {
        descriptionPlaceholder: 'Platzhalter für Beschreibung',
        amountSuffix: 'Suffix für Anzahl',
        numberSuffix: 'Suffix für Zahl',
      },
      amountToggleInput: {
        amountSuffix: 'Suffix für Zahl',
        noLabel: 'Nein-Label',
        yesLabel: 'Ja-Label',
      },
      booleanSelection: {
        noLabel: 'Nein-Label',
        yesLabel: 'Ja-Label',
      },
      sliderDropdownGroup: {
        add: 'Slider-Dropdown hinzufügen',
      },
      sliderDropdown: {
        // enableCounterWeight: 'Gegenwert aktivieren',
        // counterWeightText: 'Gegenwert-Titel',
        // leftLabel: 'Start-Punkt Beschriftung',
        // leftValueLabel: 'Start-Punkt Wert',
        // rightLabel: 'End-Punkt Beschriftung',
        // rightValueLabel: 'End-Punkt Wert',
        dropdown: {
          title: 'Dropdown-Optionen',
          add: 'Option hinzufügen',
        },
      },
      sliderGroup: {
        add: 'Slider hinzufügen',
      },
      slider: {
        enableCounterWeight: 'Gegenwert aktivieren',
        percentageLabel: 'Ist Prozentwert',
        counterWeightText: 'Gegenwert-Titel',
        leftLabel: 'Start-Punkt Beschriftung',
        leftValueLabel: 'Start-Punkt Wert',
        rightLabel: 'End-Punkt Beschriftung',
        rightValueLabel: 'End-Punkt Wert',
      },
      selection: {
        add: 'Option hinzufügen',
        allowMultiple: 'Mehrfachauswahl erlauben',
        maxMultipleChoice: 'Maximale Anzahl an Antworten',
        forceMultipleChoiceMax: 'Maximale Anzahl an Antworten erzwingen',
      },
      dynamicText: {
        maxAnswerCount: 'Maximale Anzahl an Antworten',
      },
      daySelection: {
        amountOfDaysMissing: 'Die Tagesauswahl wird automatisch ausgeblendet, da die Anzahl der Tage in der Umfrage nicht festgelegt wurde.',
      },
      organizationUnitSelection: {
        empty: 'Die Wahl der Organizationseinheit wird automatisch ausgeblendet, da keine Organisationseinheiten in der Umfrage festgelegt wurden.',
      },
      organizationUnitCooperationSelection: {
        empty:
          'Die Wahl für Organisationsschnittstellen wird automatisch ausgeblendet, da keine Organisationseinheiten in der Umfrage festgelegt wurden.',
        maxAnswerCount: 'Maximale Anzahl an Antworten',
      },
      generic: {
        title: 'Titel',
        description: 'Beschreibung',
        helpText: 'Hilfetext',
        infoImage: 'Info-Bild wählen',
        infoText: 'Info-Text',
      },
    },
    answer: {
      prefilledHintTeam:
        'Diese Umfrage wurde bereits von Ihnen ausgefüllt. Wenn Sie diese Umfrage nochmals ausfüllen, wird Ihre bisherige Antwort überschrieben und nicht gespeichert.',
      prefilledHintManager:
        'Diese Umfrage wurde bereits von einem Kollegen ausgefüllt. Wenn Sie die Werte ändern, werden die vorherigen Eingaben überschrieben und nicht gespeichert. Bitte prüfen Sie Ihre Änderungen sorgfältig.',
      prefilledHintLeader:
        'Diese Umfrage wurde bereits von einem Kollegen ausgefüllt. Wenn Sie die Werte ändern, werden die vorherigen Eingaben überschrieben und nicht gespeichert. Bitte prüfen Sie Ihre Änderungen sorgfältig.',
      infoContent: {
        label: 'Informationen ansehen',
        title: 'Informationen',
      },
      validation: {
        messages: {
          [Type.DAY_SELECTION]: 'Bitte wählen Sie einen Tag aus.',
          [Type.ORGANIZATION_UNIT_SELECTION]: 'Bitte wählen Sie Ihre Abteilung aus.',
          [Type.SLIDER_GROUP]: 'Ihre Angaben müssen insgesamt 100 % ergeben.',
          [Type.SELECTION]: 'Bitte wählen Sie mindestens eine Antwort aus.',
          [Type.SLIDER_DROPDOWN_GROUP]: 'Bitte wählen Sie für jeden verschobenen Slider eine Option aus. Die Summe aller Slider muss 100 % betragen.',
          [Type.SLIDER_DROPDOWN]: 'Bitte wählen Sie eine Option aus.',
          [Type.BOOLEAN_SELECTION]: 'Bitte wählen Sie eine Antwort aus.',
          [Type.NUMBER_INPUT]: 'Bitte geben Sie eine Zahl ein.',
          [Type.DYNAMIC_NUMBER_DESCRIPTION_AMOUNT_INPUT]: 'Bitte füllen Sie alle Felder aus.',
          [Type.AMOUNT_TOGGLE_INPUT]: 'Bitte wählen Sie die Anzahl aus.',
          [Type.ORGANIZATION_UNIT_NUMBER_INPUT]: 'Bitte geben Sie eine Zahl ein.',
          [Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION]: 'Bitte vervollständigen Sie alle gewählten Optionen.',
          [Type.ORGANIZATION_UNIT_COOPERATION_SELECTION]: 'Wählen Sie die Priorität der gewählten Abteilungen.',
        },
      },
      navigation: {
        submit: 'Absenden',
      },
      sliderGroup: {
        totalSuffix: '% / 100%',
      },
      sliderDropdown: {
        emptySelection: 'Option wählen',
      },
      selection: {
        maxMultipleChoice: (maxMultipleChoice: number) => `Wählen Sie bis zu ${maxMultipleChoice} Antworten`,
        maxMultipleChoiceForce: (maxMultipleChoice: number) => `Bitte wählen Sie ${maxMultipleChoice} Antworten`,
      },
      organizationUnitCooperationSelection: {
        priority: 'Priorität',
      },
      daySelection: {
        card: {
          title: 'Tag',
        },
      },
      previewMode: {
        watermark: 'Vorschaumodus',
      },
      submit: {
        success: 'Vielen Dank für Ihre Teilnahme!',
        error: 'Ihre Antworten konnte nicht gespeichert werden',
      },
      timeLimitReached: {
        headline: 'Abgabefrist erreicht',
        text: 'Es können keine weiteren Antworten mehr abgegeben werden.',
      },
    },
    analysis: {
      titleSplit: {
        prefix: 'Deine ',
        suffix: 'Analyse',
        subline: (customerName: string, projectName: string) => `${customerName} - Projekt: ${projectName}`,
      },
      activeConceptHeader: {
        titlePrefix: 'Aktives Konzept: ',
      },
      rebuild: {
        tooltip: 'Analyse neu erstellen',
        success: 'Analyse wurde erfolgreich neu erstellt',
        error: 'Analyse konnte nicht neu erstellt werden',
      },
      averageValues: {
        headline: 'Umfrageergebnisse.',
        answerCount: 'Antworten: ',
        noDataAvailable: 'Keine Daten verfügbar',
        filter: {
          selectOrganizationUnit: 'Organisationseinheit',
          selectDayNumber: 'Tag auswählen',
          selectDayNumberSuffix: ' Tag',
          useAll: 'Alle',
          showPlainResultsOf: {
            label: 'Zeige Ergebnisse für',
            TEAM: 'Nutzer',
            MANAGER: 'Nutzervertreter',
            LEADER: 'Entscheider',
          },
        },
        rest: 'Rest',
        sliderDropdownGroup: {
          showDetail: 'Details anzeigen',
          average: 'Durchschnitt',
          options: 'Optionsverteilung',
          noDataAvailable: 'Keine Daten verfügbar',
        },
      },
      calculation: {
        headline: 'Analyse.',
        noDataAvailable: 'Keine Analyse-Daten verfügbar',
        noData: {
          organizationUnit:
            'Bisher liegen noch keine Antworten der Organisationseinheiten vor. Mindestens eine Organisationseinheit muss beantwortet werden um die Analyse zu starten.',
        },
        calculationFailed: 'Berechnung fehlgeschlagen',
        globalValues: {
          mitarbeiterSoll: 'Mitarbeiter Soll',
          mitarbeiterSollTooltip:
            'Diese Angabe überschreibt die manuell eingegebenen Werte für Mitarbeiter-Soll in der jeweiligen Organisationseinheit.',
          anwesenheitBuero: 'Anwesenheit Büro',
          anwesenheitBueroTooltip: 'Sofern keine manuelle Eingabe innerhalb der Organisationseinheit angegeben ist, wird dieser Wert verwendet.',
        },
        ergebnisseByBueroType: {
          headline: 'Summe aller Organisationseinheiten:',
          sum: 'Gesamtfläche: ',
        },
        values: {
          headline: 'Werte nach Organisationseinheiten:',
          originalValuePrefix: 'Ursprungswert: ',
          name: {
            headline: 'Name',
          },
          productionDistance: {
            headline: 'Produktionsdistanz',
            noUnits: 'Keine Organisationseinheiten vorhanden',
          },
          floor: {
            headline: 'Stockwerk',
            noUnits: 'Keine Organisationseinheiten vorhanden',
          },
          splitting: {
            headline: 'Abteilung splitten',
            split: 'Splitten',
            remove: 'Zuweisen',
            label: 'Splitting-Option',
            option: {
              [SplitOption.HARD]: 'Harter Splitt',
              [SplitOption.SOFT]: 'Weicher Splitt',
            },
            hint: {
              [SplitOption.HARD]:
                'Harter Splitt: Die neue Organisationseinheit wird vollständig von der ursprünglichen Organisationseinheit abgekapselt. Die neue Organisationseinheit wird als selbständige Organisationseinheit betrachtet.',
              [SplitOption.SOFT]:
                'Weicher Splitt: Die neue Organisationseinheit ist in der Verwaltung ebenfalls selbstständig, wird in Diagrammen allerdings weiterhin als Teil der ursprünglichen Organisationseinheit dargestellt.',
            },
          },
          floorAssignment: {
            headline: 'Stockwerk',
          },
          mitarbeiter: {
            ist: 'Ist-Mitarbeiter',
            soll: 'Soll-Mitarbeiter',
          },
          einzelarbeit: {
            headline: 'Einzelarbeit',
            moreThanHoursHeadline: 'Fokus (Fläche) (nicht einberechnet)',
            lessThanHoursHeadline: 'Fokus (Raum)',
          },
          verkehrsflaechen: {
            headline: 'Verkehrsflächen',
          },
          meetingGroesseBesprechung: {
            headline: 'Kommunikation',
          },
          meetingGroesseCoworking: {
            headline: 'Kollaboration',
          },
          generic: {
            headline: 'Allgemein',
          },
          arbeitstag: {
            headline: 'Arbeitstag',
          },
          anwesenheit: {
            headline: 'Anwesenheit im Büro',
            ist: 'Ist-Anwesenheit',
            soll: 'Soll-Anwesenheit',
          },
          desksharing: {
            headline: 'Desksharing',
          },
          ergebnisse: {
            headline: 'Ergebnisse',
          },
          einzelbueros: {
            headline: 'Einzelbüros',
            amountSuffix: ' Einzelbüros',
          },
          sonderbedarfe: {
            headline: 'Sonderbedarfe',
            empty: 'Keine Sonderbedarfe vorhanden.',
            baseAssumption: 'Grundannahme',
            managerInput: 'Angaben des Nutzervertreters',
          },
          locker: {
            headline: 'Locker',
          },
          drucker: {
            headline: 'Drucker',
          },
          WORKSTATIONS: {
            headline: 'Workstations',
          },
          workcafe: {
            headline: 'Workcafé',
          },
          garderobe: {
            headline: 'Garderobe',
          },
          stauflaeche: {
            headline: 'Stauraum',
            headlineLaufmeter: 'Stauraum (Laufmeter)',
          },
          uebergeordneteBedarfe: {
            headline: 'Übergeordnete Bedarfe',
          },
          modell: {
            headline: 'Modell',
          },
          unitSurveyResults: {
            headline: 'Ergebnisse',
          },
          unitSurveyResultsAreas: {
            headline: 'Fläche',
          },
          unitSurveyResultsModules: {
            headline: 'Module',
            flaeche: 'Schreibtische',
            room: 'Raummodul',
            hybrid: 'Hybrid',
            sizes: {
              XS: 'XS',
              S: 'S',
              M: 'M',
              L: 'L',
              XL: 'XL',
            },
          },
          schreibtische: {
            headline: 'Schreibtische',
          },
          moreInformation: {
            headline: 'Zusätzliche Anforderungen (Nutzervertreter)',
            empty: 'Keine zusätzlichen Anforderungen vorhanden.',
          },
          organizationUnitPrioSelectionList: {
            priority: 'Priorität',
          },
          arbeitsort: {
            headline: 'Arbeitsort',
          },
          arbeitsorte: {
            headline: 'Arbeitsorte',
          },
          arbeitsplatz: {
            headline: 'Arbeitsplatz',
          },
          arbeitsplaetze: {
            headline: 'Arbeitsplätze',
          },
          sum: {
            headline: 'Summe',
          },
        },
      },
      dynamicText: {
        totalAnswerCount: 'Anzahl Eingaben: ',
      },
      chartSelector: {
        types: {
          BAR_CLUSTER: 'Balken-Cluster',
          BAR: 'Balken',
          PIE: 'Kreis',
          RELATIONSHIP: 'Kooperation',
        },
      },
      concept: {
        empty: 'Keine Arbeitsplatzkonzepte vorhanden.',
        datasetCreatedOn: 'Datenstand vom: ',
        create: {
          title: 'Arbeitsplatzkonzepte',
          cta: '+ Konzept hinzufügen',
          modalTitle: 'Konzept hinzufügen',
          hintEmptyUnits:
            'Organisationseinheiten ohne Umfrageergebnisse können nicht berücksichtigt werden und werden daher im Konzept nicht berücksichtigt.',
          name: 'Name des neuen Konzepts',
          selectBueroType: 'Modell wählen (kann später geändert werden)',
          success: 'Konzept wurde erfolgreich angelegt.',
          error: 'Konzept konnte nicht angelegt werden.',
          basis: {
            cta: '+ Basiskonzepte anlegen',
            modalTitle: 'Basiskonzepte anlegen',
            noOverwriteHint: 'Existierende Basiskonzepte werden nicht überschrieben.',
          },
        },
        copy: {
          error: 'Konzept konnte nicht kopiert werden.',
          titleSuffix: ' kopieren',
        },
        update: {
          error: 'Konzept konnte nicht gespeichert werden.',
        },
        optimization: {
          headline: '2. Optimierung',
          mode: {
            title: 'Berechnung der Arbeitsorte',
            [OptimizationMode.STANDARD]: 'Standard',
            [OptimizationMode.MAX]: 'Max',
            [OptimizationMode.MIN]: 'Min',
            [OptimizationMode.MIX]: 'Mix',
          },
          verkehrsflaechenPercentage: 'Anteil Verkehrsflächen',
          uebergeordneteBedarfe: {
            title: 'Übergeordnete Bedarfe',
            byNorm: {
              yes: 'Nach Empfehlung',
              no: 'Individuell angegeben',
            },
          },
        },
        summary: {
          general: {
            title: 'Zusammenfassung',
            generalTitle: 'Zusammenfassung Gesamt',
            areaTotal: 'Benötigte Gesamtfläche',
            areaTotalIst: 'Ist-Fläche',
            areaDifference: 'Flächenabweichung',
            employeeAmount: 'Mitarbeiterzahl',
            deskAmount: 'Schreibtische',
            desksharingQuoteAverage: 'Desksharing-Quote',
            anwesenheitAverage: 'Anwesenheit',
            organizationUnitAmount: 'Organisationseinheiten',
            amountWorkplaces: 'Anzahl Arbeitsmöglichkeiten',
            amountWorkstations: 'Anzahl Workstations',
            squareMeterPerMitarbeiter: 'Fläche pro Mitarbeiter',
            squareMeterPerMitarbeiterSuffix: ' m² / MA',
          },
          productionDistance: {
            fern: {
              title: 'Zusammenfassung Produktionsfern',
            },
            nah: {
              title: 'Zusammenfassung Produktionsnah',
            },
          },
          floorSummary: {
            title: (floorName: string) => `Zusammenfassung Stockwerk ${floorName}`,
          },
          floors: {
            headline: 'Stockwerke',
            total: 'Gesamt',
            showDetail: 'Vergleich anzeigen',
            quickAssignment: {
              headline: 'Zuweisung der Stockwerke',
              cta: 'Zuweisung öffnen',
              floorComparison: 'Vergleich aller Stockwerke einblenden',
              verortung: {
                label: 'Räumliche Verortung',
                cta: 'Räumliche Verortung öffnen',
                hint: (unitName: string) =>
                  `Angabe des Nutzervertreters hinsichtlich der Räumlichen Verortung der Organisationseinheit ${unitName}. Sortiert nach Priorität.`,
              },
            },
          },
          areaOverview: {
            title: 'Übersicht der Flächen',
            arbeitsplaetze: {
              label: 'Arbeitsplätze',
              einzelbueros: 'Einzelbüros (Arbeitsplatz)',
              KLASSISCHE_ARBEIT: 'Einzelarbeit - Klassisch (Arbeitsplatz)',
              FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR: 'Einzelarbeit - Fokus (Arbeitsplatz)',
              FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR: 'Einzelarbeit - Fokus (Arbeitsort)',
              notRelevant: 'Nicht in die Summe einbezogen',
            },
            arbeitsorte: {
              label: 'Arbeitsorte',
              KOMMUNIKATION_PERSON_2: 'Kommunikation: 1-2 (Arbeitsort)',
              KOMMUNIKATION_PERSON_3_4: 'Kommunikation: 3-4 (Arbeitsort)',
              KOMMUNIKATION_PERSON_5_8: 'Kommunikation: 5-8 (Arbeitsort)',
              KOMMUNIKATION_PERSON_9_12: 'Kommunikation: 9-12 (Arbeitsort)',
              KOMMUNIKATION_PERSON_13_16: 'Kommunikation: 13-16 (Arbeitsort)',
              KOLLABORATION_PERSON_2_4: 'Kollaboration: 2-4 (Arbeitsort)',
              KOLLABORATION_PERSON_5_8: 'Kollaboration: 5-8 (Arbeitsort)',
              KOLLABORATION_PERSON_9_12: 'Kollaboration: 9-12 (Arbeitsort)',
              KOLLABORATION_PERSON_13_16: 'Kollaboration: 13-16 (Arbeitsort)',
              HYBRID_PERSON_XS: 'Hybrid: 1-2 (Arbeitsort)',
              HYBRID_PERSON_S: 'Hybrid: 3-4 (Arbeitsort)',
              HYBRID_PERSON_M: 'Hybrid: 5-8 (Arbeitsort)',
              HYBRID_PERSON_L: 'Hybrid: 9-12 (Arbeitsort)',
              HYBRID_PERSON_XL: 'Hybrid: 13-16 (Arbeitsort)',
            },
            sonderbedarfe: {
              label: 'Sonderbedarfe (Nutzervertreter)',
              locker: 'Locker',
              drucker: 'Drucker',
              workcafe: 'Workcafé',
              garderobe: 'Garderobe',
            },
            uebergeordneteBedarfe: {
              label: 'Übergeordnete Bedarfe',
              oePrefix: 'OE: ',
            },
            stauraum: 'Stauraum',
            verkehrsflaechen: {
              label: 'Verkehrsflächen',
            },
            total: 'Gesamt',
          },
          modules: {
            title: 'Übersicht der Module',
            arbeitsplaetzeSuffix: ' Arbeitsmöglichkeiten',
            arbeitsorteLabel: 'Arbeitsorte',
            arbeitsplaetzeLabel: 'Arbeitsplätze (Schreibtische)',
          },
        },
        additionalConfiguration: {
          title: 'Zusätzliche Konfiguration',
        },
        sonderbedarfe: {
          title: 'Sonderbedarfe (Nutzervertreter)',
        },
        activeConcept: {
          prefix: 'Ausgewähltes Arbeitsplatzkonzept: ',
        },
        unit: {
          headline: '3. Individualisierung der Organisationseinheiten',
        },
        graph: {
          headline: '1. Übersicht',
          transparency: 'Ansicht ändern',
        },
        unitComparison: {
          name: 'Flächenvergleich',
        },
        anwesenheitComparison: {
          name: 'Anwesenheit',
        },
        desksharingComparison: {
          name: 'Desksharing',
        },
        mitarbeiterComparison: {
          name: 'Mitarbeiter',
        },
        comparison: {
          headline: 'Vergleichsdiagramme',
        },
        unitCopy: {
          titleSuffix: ' splitten',
          hint: 'Alle Einstellungen, Umfrageergebnisse und weitere Informationen werden übernommen.',
        },
        unitRemove: {
          titleSuffix: ' zuweisen',
          hint: 'Alle Einstellungen dieser Organisationseinheit werden gelöscht.',
          maReceiverUnit: 'Zu welcher Organisationseinheit sollen die Mitarbeiter verschoben werden?',
        },
      },
      info: {
        headline: 'Allgemeine Informationen',
        participationRate: {
          title: 'Beteiligungsquoten',
          unitPrefix: 'OE: ',
          byManager: 'Nutzervertreter',
          byLeader: 'Entscheider',
          oeWithoutManagerAnswer: 'OE ohne Nutzervertreterantwort: ',
          total: 'Gesamt: ',
          answersPrefix: 'Antworten: ',
          personAmountPrefix: 'Personen: ',
          of: ' von ',
        },
      },
    },
    attributes: {
      departmentName: 'Abteilungsname',
      professionalGroup: 'Berufsgruppe',
      professionalGroupOption: {
        WHITE_COLLAR: 'White-Collar',
        BLUE_COLLAR: 'Blue-Collar',
      },
      employeeAmount: 'Anzahl Mitarbeiter',
      location: 'Standort',
      description: 'Beschreibung',
      deadline: 'Abgabefrist',
      amountOfDays: 'Anzahl Tage',
      floors: 'Stockwerke',
      totalAnswerCount: 'Anzahl Abgaben',
      surveyThankYouHeadline: 'Dankesnachricht - Überschrift',
      surveyThankYouText: 'Dankesnachricht - Text',
      surveyTimeLimitReachedHeadline: 'Zeitlimit erreicht - Überschrift',
      surveyTimeLimitReachedText: 'Zeitlimit erreicht - Text',
    },
    elements: {
      types: {
        ANWESENHEIT: 'Anwesenheit',
        ARBEITSTAG: 'Arbeitstag',
        EINZELARBEIT: 'Einzelarbeit-Zusammensetzung',
        MEETING_GROESSE_BESPRECHUNG: 'Besprechungsgröße',
        MEETING_GROESSE_COWORKING: 'Coworking-Größe',
        TELEPHONE_MORE_THEN: 'Telefonate',
        STAUFLAECHE: 'Staufläche',
        SONDERBEDARFE: 'Sonderbedarfe',
        SONDERBEDARFE_ZUSATZ: 'Zusätzlich Sonderbedarfe',
        WORKSTATIONS: 'Workstations',
        RAEUMLICHE_VERORTUNG: 'Räumliche Verortung',
        RAEUMLICHE_VERORTUNG_NEIN: 'Keine Räumliche Verortung',
        EINZELBUEROS: 'Einzelbüros',
        UEBERGEORDNETE_BEDARFE: 'Übergeordnete Bedarfe',
        DAY_SELECTION: 'Tagesauswahl',
        ORGANIZATION_UNIT_SELECTION: 'Wahl der Organisationseinheit',
        ORGANIZATION_UNIT_COOPERATION_SELECTION: 'Wahl der Organisationsschnittstellen',
        STATIC_TEXT: 'Info-Text',
        SLIDER: 'Slider',
        SELECTION: 'Auswahl',
        DYNAMIC_TEXT: 'Textantworten',
        SLIDER_GROUP: 'Slider-Gruppe',
        SLIDER_DROPDOWN: 'Slider-Dropdown',
        SLIDER_DROPDOWN_GROUP: 'Slider-Dropdown-Gruppe',
        BOOLEAN_SELECTION: 'Ja/Nein-Auswahl',
      },
    },
    bueroType: {
      types: {
        KOMFORT: 'Multispace - Komfort',
        FLEX: 'Multispace - Flex',
        AGIL: 'Multispace - Agil',
        ZELLSTRUKTUR: 'Zellenstruktur',
        OPEN_SPACE: 'Open Space',
      },
    },
    prebuildType: {
      types: {
        DESKSHARING: 'Desksharing',
        ANWESENHEIT: 'Anwesenheit',
        EINZELARBEIT: 'Einzelarbeit',
        KOMMUNIKATION: 'Kommunikation',
        KOLLABORATION: 'Kollaboration',
        KLASSISCHE_ARBEIT: 'Einzel (Klassisch)',
        FOKUSSIERTE_ARBEIT_MORE_THEN_HOUR: 'Einzel (Fokus - Arbeitsplatz)',
        FOKUSSIERTE_ARBEIT_LESS_THEN_HOUR: 'Einzel (Fokus - Arbeitsort)',
        PERSON_2: '2 Personen',
        PERSON_3_4: '3-4 Personen',
        PERSON_5_8: '5-8 Personen',
        PERSON_9_12: '9-12 Personen',
        PERSON_13_16: '13-16 Personen',
        PERSON_2_4: '2-4 Personen',
        EINZELBUEROS: 'Einzelbüros',
      },
    },
  },

  settings: {
    title: 'Einstellungen',
    access: {
      title: 'Zugriffsrechte',
      upsert: {
        title: 'Zugriff hinzufügen',
        cta: 'Zugriff hinzufügen',
        success: 'Zugriff wurde erfolgreich gespeichert',
        error: {
          upsert: 'Zugriff konnte nicht gespeichert werden',
          remove: 'Zugriff konnte nicht gelöscht werden',
          loading: 'Zugriffe konnten nicht geladen werden',
        },
        edit: 'Zugriff bearbeiten',
        remove: {
          title: 'Zugriff löschen',
          hint: 'Sind Sie sicher, dass Sie diesen Zugriff löschen möchten?',
          error: 'Zugriff konnte nicht gelöscht werden',
        },
      },
      entry: {
        attributes: {
          name: 'Name',
          exportKey: 'Export-Schlüssel',
        },
        add: {
          title: 'Einträge verwalten',
          cta: 'Erstellen',
          error: 'Eintrag konnte nicht hinzugefügt werden',
        },
      },
    },
  },

  footer: {
    links: 'Links',
    followUs: 'Folge uns auf',
    legalLinks: [
      { name: 'Kontakt', link: 'https://www.mps-archonic.com/kontakt/' },
      { name: 'Impressum', link: 'https://www.mps-archonic.com/impressum/' },
      { name: 'Datenschutz', link: 'https://www.mps-archonic.com/datenschutz/' },
    ],
    socialLinks: [
      { icon: 'facebook', link: 'https://www.facebook.com/createworkflow/' },
      { icon: 'instagram', link: 'https://www.instagram.com/archonic.gmbh/' },
      { icon: 'linkedin', link: 'https://www.linkedin.com/company/archonic-createworkflow/' },
    ],
  },

  generic: {
    level: {
      title: 'Rolle',
      ADMIN: 'Administrator',
      MEMBER: 'Mitarbeiter',
    },
    company: {
      name: 'MPS ARCHONIC Group GmbH',
      street: 'Stuttgarter Straße 66',
      city: '74321 Bietigheim-Bissingen',
      phone: '07142 / 22640006',
      mail: 'mail@mps-archonic.com',
    },
    remove: 'Löschen',
    mitarbeiterAmount: 'Mitarbeiteranzahl',
    download: 'Download',
    amountSuffix: ' Stück',
    meterSuffix: ' Meter',
    laufmeterSuffix: ' Laufmeter',
    settings: 'Einstellungen',
    hourSuffix: ' Stunden',
    squareMeter: 'Quadratmeter',
    squareMeterSuffix: ' m²',
    cubicMeterSuffix: ' m³',
    percentageSuffix: ' %',
    euroSuffix: ' €',
    equals: ' = ',
    timestampPrefix: 'Erstellt am: ',
    phonePrefix: 'Telefon: ',
    mailPrefix: 'E-Mail: ',
    websitePrefix: 'Webseite: ',
    employeeSuffix: ' Mitarbeiter',
    salutation: 'Anrede',
    name: 'Name',
    firstname: 'Vorname',
    lastname: 'Nachname',
    birthday: 'Geburtsdatum',
    personType: 'Art',
    personTypePlaceholder: 'Beirat, Entscheider, ...',
    street: 'Straße, Hausnummer',
    companyName: 'Firmenname',
    club: 'Verein (optional)',
    city: 'PLZ, Ort',
    mail: 'E-Mail-Adresse',
    identifier: 'E-Mail-Adresse',
    message: 'Ihre Anfrage...',
    phone: 'Telefonnummer',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    createdOn: 'Erstellt am',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    close: 'Schließen',
    send: 'Senden',
    error: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.',
    acceptAGB: 'Ich akzeptiere die AGB',
    percent: ' %',
    kilometerSuffix: ' km',
    upload: 'Hochladen',
    login: 'Anmelden',
    logout: 'Abmelden',
    export: 'Export',
    import: 'Import',
    save: 'Speichern',
    copy: 'Kopieren',
  },

  UI: {
    removeConfirmation: {
      title: 'Bestätigung',
      text: (itemName: string) => `Möchten Sie "${itemName}" wirklich löschen?`,
    },
    copyConfirmation: {
      title: 'Kopieren',
      text: (itemName: string) => `${itemName}-Kopie umbenennen zu:`,
      initNameSuffix: '-Kopie',
    },
    customerSelector: {
      label: 'Kundenauswahl',
    },
    projectSelector: {
      label: 'Projektauswahl',
    },
    floorManager: {
      title: 'Stockwerke',
      addTitle: 'Stockwerk hinzufügen',
      updateTitle: 'Stockwerk bearbeiten',
      empty: 'Keine Stockwerke vorhanden',
      add: 'hinzufügen',
    },
    contactPersonManager: {
      title: 'Kontaktpersonen',
      addTitle: 'Kontaktperson hinzufügen',
      updateTitle: 'Kontaktperson bearbeiten',
      empty: 'Keine Kontaktpersonen vorhanden',
      add: 'hinzufügen',
    },
    organizationUnitManager: {
      title: 'Organisationseinheiten',
      addTitle: 'Organisationseinheit hinzufügen',
      employeeAmountSuffixShort: ' MA',
      employeeAmountSuffix: ' Mitarbeiter',
      updateTitle: 'Organisationseinheit bearbeiten',
      productionDistance: {
        title: 'Produktionsnähe',
        [ProductionDistance.NAH]: 'Produktionsnah',
        [ProductionDistance.FERN]: 'Produktionsfern',
      },
      empty: 'Keine Organisationseinheiten vorhanden',
      add: 'hinzufügen',
    },
    simpleList: {
      search: 'Suche',
      resultAmountSuffixPlural: ' Ergebnisse',
      resultAmountSuffixSingular: ' Ergebnis',
      noData: 'Keine Daten vorhanden',
    },
    multiList: {
      search: 'Suche',
      resultAmountSuffix: ' Ergebnisse',
      noData: 'Keine Daten vorhanden',
      cta: 'Ausführen',
      cancelCTA: 'Abbrechen',
      option: {
        EXPORT: 'Export',
        PROCESS: 'Verarbeiten',
        STOP: 'Stoppen',
      },
      export: {
        title: 'Export',
        identifier: 'Kennung',
      },
      error: 'Aktion konnte nicht ausgeführt werden',
    },
    csvImport: {
      title: 'Import',
      startCTA: 'Import starten',
      loading: 'Daten werden imporiert...',
      error: 'Der Import ist fehlgeschlagen.',
    },
    dropdown: {
      emptySelection: 'Bitte wählen',
      search: 'Suche',
    },
    selectableTagList: {
      showMore: 'Mehr anzeigen',
      showLess: 'Weniger',
    },
    textarea: {
      max: {
        prefix: 'maximal ',
        suffix: ' Zeichen',
      },
    },
    dnd: {
      text: 'Bewerbung anhängen',
      hint: '(Erlaubt ist eine PDF-Datei bis zu 25 MB)',
      selectedPrefix: 'Gewählte PDF: ',
      error: {
        size: 'Maximale Dateigröße überschritten',
      },
    },
  },

  resetPassword: {
    passwordsDontMatch: 'Passwörter stimmen nicht überein',
    passwordReset: 'Passwort wurde erfolgreich geändert',
    save: 'Ändern',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    title: 'Passwort ändern',
  },
}

export const langKey = 'DE'
